export const LISTING_TOOLTIP_CLICKED: "Onboarding.MyGrails.LISTING_TOOLTIP_CLICKED" =
  "Onboarding.MyGrails.LISTING_TOOLTIP_CLICKED";
export type ListingTooltipClickedAction = {
  type: typeof LISTING_TOOLTIP_CLICKED;
};
export const listingTooltipClickedActionCreator =
  (): ListingTooltipClickedAction => ({
    type: LISTING_TOOLTIP_CLICKED,
  });
